<template>
  <div
    :class="[
      `sc-weather-widget__block sc-weather-widget__block--bottom ${$mq}`
    ]"
    slot="second-footer"
  >
    <div
      class="sc-weather-widget__block-item"
      v-for="(item, i) in weatherForecast"
      :key="i"
    >
      <r-text
        :size="$mq === `r_medium` ? 12 : 14"
        type="caption"
        v-if="i === 0"
        >{{ $t("weather-widget:time-now") }}</r-text
      >
      <r-text :size="$mq === `r_medium` ? 12 : 14" type="caption" v-else>{{
        getTime(item.dt_txt)
      }}</r-text>
      <r-icon
        :name="getWeatherIconName(item.weather[0].id, getHour(item.dt_txt))"
        :size="$mq === `r_medium` ? 20 : 30"
      />
      <r-text :size="$mq === `r_medium` ? 14 : 16" type="caption"
        >{{ getTemp(item.main.temp) }}°</r-text
      >
    </div>
  </div>
</template>

<script>
import { getWeatherIconName } from "../../../../configs";

export default {
  props: {
    weatherForecast: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      getWeatherIconName
    };
  },
  methods: {
    getTime(value) {
      return value
        .split(" ")
        .pop()
        .split(":")
        .slice(0, -1)
        .join(":");
    },
    getHour(value) {
      return Number(
        value
          .split(" ")
          .pop()
          .split(":")[0]
      );
    },
    getTemp(value) {
      const temp = Math.trunc(value);

      return temp > 0 ? `+${temp}` : temp;
    }
  }
};
</script>

<style lang="scss">
.sc-weather-widget {
  &__block {
    &--bottom {
      .sc-weather-widget__block-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 20%;
        div {
          margin-bottom: 8px !important;
          &:last-child {
            margin-bottom: 0 !important;
          }
        }
      }
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "weather-widget:time-now": "Сейчас"
  },
  "en": {
    "weather-widget:time-now": "Now"
  }
}
</i18n>
